import { FormikProps } from 'formik';
import { csvColumnMatcher } from 'utils/csvColumnMatcher';
import { FormValues } from '../types';
import { useEffect } from 'react';

export const useCsvColumnMatcher = ({
  columns,
  formik
}: {
  columns: string[];
  formik: FormikProps<FormValues>;
}) => {
  const mapping = csvColumnMatcher(columns);

  useEffect(() => {
    if (columns.length > 0) {
      formik.setFieldValue('csvColumns', mapping);
    }
  }, [JSON.stringify(mapping)]);
};
